<template>
  <div class="app-wrapper">
    <navbar />
    <app-main />
    <!-- <footbar/> -->
  </div>
</template>

<script>
import { Navbar, AppMain } from './components/index'

export default {
  components: {
    Navbar: Navbar,
    AppMain: AppMain
    // Footbar: Footbar
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";
.app-main {
  background-color: #F4F5F5;
  min-height: 100%
}
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }
</style>
